'use client'

import {
 useForm,
 type UseFormProps,
 type FieldValues,
} from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { type z } from 'zod'

export interface AppFormOptions<
 Input extends FieldValues,
 Output extends FieldValues,
> extends Omit<UseFormProps<Input, unknown, Output>, 'resolver'> {
 schema: z.ZodType<Output, Input>
}

export function useAppForm<
 Input extends FieldValues,
 Output extends FieldValues,
>({ schema, mode = 'onBlur', ...options }: AppFormOptions<Input, Output>) {
 return useForm<Input, unknown, Output>({
  resolver: zodResolver(schema),
  mode,
  ...options,
 })
}
